/**
 * Phase 35 — a metric's judged days as one small inline line (no chart
 * library): oldest on the left, scaled to its own min and max; the hover
 * lists the days.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

const W = 64;
const H = 14;

export const Sparkline: FC<{ values: number[]; title: string; className?: string }> = ({ values, title, className }) => {
  if (values.length < 2) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const points = values.map((v, i) => `${((i / (values.length - 1)) * (W - 2) + 1).toFixed(1)},${(H - 1 - ((v - min) / span) * (H - 2)).toFixed(1)}`).join(' ');
  return (
    <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} className={className} role="img" aria-label={title} data-testid="sparkline">
      <title>{title}</title>
      <polyline points={points} fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
};
